import { render, staticRenderFns } from "./ServicesByMinisID.vue?vue&type=template&id=dd1db13e&scoped=true&"
import script from "./ServicesByMinisID.vue?vue&type=script&lang=js&"
export * from "./ServicesByMinisID.vue?vue&type=script&lang=js&"
import style0 from "./ServicesByMinisID.vue?vue&type=style&index=0&id=dd1db13e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1db13e",
  null
  
)

export default component.exports